import { create } from "zustand";
import { createSelectors } from ".";
import {
  createDBTCommitModelsSlice,
  DBTCommitModelsActions,
  DBTCommitModelsSlice,
} from "./slices/dbtInterruptSlices/dbtCommitModelsSlice";
import {
  createDBTGithubConfigSlice,
  DBTGithubConfigActions,
  DBTGithubConfigSlice,
} from "./slices/dbtInterruptSlices/dbtGithubConfigSlice";
import {
  createDBTQuerySelectionSlice,
  DBTQuerySelectionActions,
  DBTQuerySelectionSlice,
} from "./slices/dbtInterruptSlices/dbtQuerySelectionSlice";

interface DBTInterruptStoreActions {
  hasDBTConfig: () => boolean;
  clearAllDBTConfigs: () => void;
}

// Combined actions type - flattened like useSessionActions
export type DBTInterruptActions = DBTInterruptStoreActions &
  DBTGithubConfigActions &
  DBTQuerySelectionActions &
  DBTCommitModelsActions;

interface DBTInterruptStoreSlice {
  actions: DBTInterruptStoreActions;
}

// Combined store type
type DBTInterruptStore = DBTInterruptStoreSlice &
  DBTGithubConfigSlice &
  DBTQuerySelectionSlice &
  DBTCommitModelsSlice;

const useDBTInterruptBase = create<DBTInterruptStore>()((set, get, api) => ({
  // Main store state and actions
  actions: {
    hasDBTConfig: () => {
      const state = get();
      return Boolean(
        state.github_config ||
          state.query_selection_config ||
          state.commit_models_config
      );
    },
    clearAllDBTConfigs: () => {
      const state = get();
      state.githubActions.clearDBTGithubConfig();
      state.querySelectionActions.clearDBTQuerySelectionConfig();
      state.commitModelsActions.clearDBTCommitModelsConfig();
    },
  },

  // Include all slices
  ...createDBTGithubConfigSlice(set, get, api),
  ...createDBTQuerySelectionSlice(set, get, api),
  ...createDBTCommitModelsSlice(set, get, api),
}));

export const useDBTInterruptStore = createSelectors(useDBTInterruptBase);

// Custom hook that combines all actions - following your useSessionActions pattern
export const useDBTInterruptActions = (): DBTInterruptActions => {
  const store = useDBTInterruptStore();

  return {
    ...store.actions,
    ...store.githubActions,
    ...store.querySelectionActions,
    ...store.commitModelsActions,
  };
};
